import Arrow from "./arrow";

class Game {
  constructor(stage) {
    this.stage = stage;
    this.started = false;
    this.RleftArrows = [];
    this.RdownArrows = [];
    this.RupArrows = [];
    this.RrightArrows = [];
    this.frank = {
      dancer: null,
      init: false,
      mode: 'starting',
      current: 'none',
      lastUpdate: 0,
      newDir: ''
    };
    this.play = this.play.bind(this);
    this.music = new Audio('./assets/songs/el-porompompero.mp4');
    this.music.loop = true;
    this.music.volume = 0.1;
    this.reset();

    document.getElementById("mute")
      .addEventListener("click", () => {
        if (this.music.muted) {
          $("i").removeClass("fa fa-volume-off");
          $("i").addClass("fa fa-volume-up");
        } else {
          $("i").removeClass("fa fa-volume-up");
          $("i").addClass("fa fa-volume-off");
        }
        this.music.muted = !this.music.muted;
      });
  }

  reset() {
    this.score = 0;
    this.life = 100;
    this.updateScore();
    this.clearArrows();
    createjs.Ticker.removeAllEventListeners();
    this.stage.update();
    clearInterval(this.myInt);
  }

  clearArrows() {
    this.RleftArrows.forEach(arrow => { this.stage.removeChild(arrow); });
    this.RdownArrows.forEach(arrow => { this.stage.removeChild(arrow); });
    this.RupArrows.forEach(arrow => { this.stage.removeChild(arrow); });
    this.RrightArrows.forEach(arrow => { this.stage.removeChild(arrow); });
    this.RleftArrows = [];
    this.RdownArrows = [];
    this.RupArrows = [];
    this.RrightArrows = [];
  }

  play(difficulty) {
    this.started = true;
    let speed;
    switch(difficulty) {
      case "light":
        speed = 3.5;

        this.music = new Audio('./assets/songs/samba-07.mp3');
        this.music.loop = true;
        this.music.volume = 0.2;
        break;
      case "standard":
        speed = 5.5;

        this.music = new Audio('./assets/songs/el-porompompero.mp4');
        this.music.loop = true;
        this.music.volume = 0.3;
        break;
      case "heavy":
        speed = 7.0;
        break;
    }

    let that = this;

    this.reset();
    clearTimeout(this.t1);
    clearTimeout(this.t2);
    clearTimeout(this.t3);
    clearTimeout(this.t4);
    this.music.play();

    setInterval(() => {speed *= 1.0007;} , 100 );
    this.myInt = setInterval( randomGen, 7000 / 3 / speed );

    this.t1 = setTimeout(() => {
      clearInterval(this.myInt);
      if (this.life > 0) {
        this.myInt = setInterval( randomGen, 7500 / 3 / speed);
      }
    }, 52500);

    this.t2 = setTimeout(() => {
      clearInterval(this.myInt);
      if (this.life > 0) {
        this.myInt = setInterval( randomGen, 8000 / 3 / speed);
      }
    }, 105000);

    this.t3 = setTimeout(() => {
      clearInterval(this.myInt);
      if (this.life > 0) {
        this.myInt = setInterval( randomGen, 8500 / 3 / speed);
      }
    }, 157500);

    this.t4 = setTimeout(() => {
      clearInterval(this.myInt);
      if (this.life > 0) {
        this.myInt = setInterval( randomGen, 9000 / 3 / speed);
      }
    }, 210000);

    let tick = createjs.Ticker;
    tick.setFPS(30);

    const CreateDancingFrank = () => {
      if (that.frank.init === false) {
        that.frank.dancer = new Arrow.DFrank();
        that.stage.addChild(that.frank.dancer.wide);
        that.stage.update();
        that.frank.init = true;
        that.frank.current = 'start';
      }

      let listener = tick.on("tick", updateFrank);

      function clearFrank () {
        that.stage.removeChild(that.frank.dancer.wide);
        that.stage.removeChild(that.frank.dancer.prepared);
        that.stage.removeChild(that.frank.dancer.side);
        that.stage.removeChild(that.frank.dancer.ole);
        that.stage.removeChild(that.frank.dancer.magic);
      }


      function drawFrank (state) {
        if (state !== '' && state !== that.frank.current) {
          clearFrank();
          if (state == 'wide') {
            that.stage.addChild(that.frank.dancer.wide);
          } else if (state == 'prepared') {
            that.stage.addChild(that.frank.dancer.prepared);
          } else if (state == 'side') {
            that.stage.addChild(that.frank.dancer.side);
          } else if (state == 'ole') {
            that.stage.addChild(that.frank.dancer.ole);
          } else {
            that.stage.addChild(that.frank.dancer.magic);
          }

          that.frank.current = state;
          that.stage.update();
        }
      }

      function changeFrank (state) {
        if (state !== that.frank.current) {
          drawFrank(state);
          that.frank.lastUpdate = 0;
        }
      }

      function updateFrank (event) {
        if (that.frank.current == 'start') {
          if (that.frank.lastUpdate > 60) {
            drawFrank('prepared');
            that.frank.lastUpdate = 0;
          }
        } else {
          if (that.frank.newDir !== '' ) {
            let newState = '';
            switch (that.frank.newDir) {
              case 'up':
                newState = 'wide';
                break;
              case 'down':
                newState = 'ole';
                break;
              case 'left':
                newState = 'side';
                break;
              case 'right':
                newState = 'magic';
                break;
            }
            drawFrank(newState);
            that.frank.lastUpdate = 0;
            that.frank.newDir = '';
          } else {
            if (that.frank.lastUpdate > 10) {
              drawFrank('prepared');
              that.frank.lastUpdate = 0;
            }
          }
        }

        that.frank.lastUpdate++;
      }
    };

    const LcreateLeftArrow = () => {
      let leftMovingArrow = new Arrow.LleftArrow();
      that.LleftArrows.push(leftMovingArrow);
      that.stage.addChild(leftMovingArrow);
      that.stage.update();
      let listener = tick.on("tick", leftTick);
      leftMovingArrow.listener = listener;

      function leftTick(event) {
        leftMovingArrow.y = leftMovingArrow.y - speed;
        if (that.LleftArrows[0] && that.LleftArrows[0].y < -40) {
          that.miss();
          that.stage.removeChild(that.LleftArrows[0]);
          that.LleftArrows.shift();
          tick.off("tick", listener);
        }
        that.stage.update(event);
      }
    };

    const LcreateDownArrow = () => {
      let downMovingArrow = new Arrow.LdownArrow();
      that.LdownArrows.push(downMovingArrow);
      that.stage.addChild(downMovingArrow);
      that.stage.update();
      let listener = tick.on("tick", downTick);
      downMovingArrow.listener = listener;

      function downTick(event) {
        downMovingArrow.y = downMovingArrow.y - speed;
        if (that.LdownArrows[0] && that.LdownArrows[0].y < -40) {
          that.miss();
          that.stage.removeChild(that.LdownArrows[0]);
          that.LdownArrows.shift();
          tick.off("tick", listener);
        }
        that.stage.update(event);
      }
    };

    const LcreateUpArrow = () => {
      let upMovingArrow = new Arrow.LupArrow();
      that.LupArrows.push(upMovingArrow);
      that.stage.addChild(upMovingArrow);
      that.stage.update();
      let listener = tick.on("tick", upTick);
      upMovingArrow.listener = listener;

      function upTick(event) {
        upMovingArrow.y = upMovingArrow.y - speed;
        if (that.LupArrows[0] && that.LupArrows[0].y < -40) {
          that.miss();
          that.stage.removeChild(that.LupArrows[0]);
          that.LupArrows.shift();
          tick.off("tick", listener);
        }
        that.stage.update(event);
      }
    };

    const LcreateRightArrow = () => {
      let rightMovingArrow = new Arrow.LrightArrow();
      that.LrightArrows.push(rightMovingArrow);
      that.stage.addChild(rightMovingArrow);
      that.stage.update();
      let listener = tick.on("tick", rightTick);
      rightMovingArrow.listener = listener;

      function rightTick(event) {
        rightMovingArrow.y = rightMovingArrow.y - speed;
        if (that.LrightArrows[0] && that.LrightArrows[0].y < -40) {
          that.miss();
          that.stage.removeChild(that.LrightArrows[0]);
          that.LrightArrows.shift();
          tick.off("tick", listener);
        }
        that.stage.update(event);
      }
    };

    const RcreateLeftArrow = () => {
      let leftMovingArrow = new Arrow.RleftArrow();
      that.RleftArrows.push(leftMovingArrow);
      that.stage.addChild(leftMovingArrow);
      that.stage.update();
      let listener = tick.on("tick", leftTick);
      leftMovingArrow.listener = listener;

      function leftTick(event) {
        leftMovingArrow.y = leftMovingArrow.y - speed;
        if (that.RleftArrows[0] && that.RleftArrows[0].y < -40) {
          that.miss();
          that.stage.removeChild(that.RleftArrows[0]);
          that.RleftArrows.shift();
          tick.off("tick", listener);
        }
        that.stage.update(event);
      }
    };

    const RcreateDownArrow = () => {
      let downMovingArrow = new Arrow.RdownArrow();
      that.RdownArrows.push(downMovingArrow);
      that.stage.addChild(downMovingArrow);
      that.stage.update();
      let listener = tick.on("tick", downTick);
      downMovingArrow.listener = listener;

      function downTick(event) {
        downMovingArrow.y = downMovingArrow.y - speed;
        if (that.RdownArrows[0] && that.RdownArrows[0].y < -40) {
          that.miss();
          that.stage.removeChild(that.RdownArrows[0]);
          that.RdownArrows.shift();
          tick.off("tick", listener);
        }
        that.stage.update(event);
      }
    };

    const RcreateUpArrow = () => {
      let upMovingArrow = new Arrow.RupArrow();
      that.RupArrows.push(upMovingArrow);
      that.stage.addChild(upMovingArrow);
      that.stage.update();
      let listener = tick.on("tick", upTick);
      upMovingArrow.listener = listener;

      function upTick(event) {
        upMovingArrow.y = upMovingArrow.y - speed;
        if (that.RupArrows[0] && that.RupArrows[0].y < -40) {
          that.miss();
          that.stage.removeChild(that.RupArrows[0]);
          that.RupArrows.shift();
          tick.off("tick", listener);
        }
        that.stage.update(event);
      }
    };

    const RcreateRightArrow = () => {
      let rightMovingArrow = new Arrow.RrightArrow();
      that.RrightArrows.push(rightMovingArrow);
      that.stage.addChild(rightMovingArrow);
      that.stage.update();
      let listener = tick.on("tick", rightTick);
      rightMovingArrow.listener = listener;

      function rightTick(event) {
        rightMovingArrow.y = rightMovingArrow.y - speed;
        if (that.RrightArrows[0] && that.RrightArrows[0].y < -40) {
          that.miss();
          that.stage.removeChild(that.RrightArrows[0]);
          that.RrightArrows.shift();
          tick.off("tick", listener);
        }
        that.stage.update(event);
      }
    };

    CreateDancingFrank();

    setTimeout(function () {
      document.getElementById("canvas").style.background = "none";
      document.getElementById("danceloop").play();
    }, 600);

    function randomGen() {
      let randArrow = Math.floor(Math.random() * 5) + 1;
      let randDouble = Math.random() * 100 + 1;
      if (difficulty === "heavy") {
        if (randDouble > 75) {
          randArrow += 5;
        }
      }

      switch(randArrow) {
        case 1: RcreateLeftArrow();  break;
        case 2: RcreateDownArrow();  break;
        case 3: RcreateUpArrow();    break;
        case 4: RcreateRightArrow(); break;
        case 5: break;
        case 6: break;
        case 7: break;
        case 8: break;
        case 9: break;
        case 10: break;
      }
    }
  }

  check(arrows, direction) {
    let pressed;
    switch(direction) {
      case "r_left":
        this.frank.newDir = 'left';
        pressed = new Arrow.RleftPressedArrow();
        break;
      case "r_down":
        this.frank.newDir = 'down';
        pressed = new Arrow.RdownPressedArrow();
        break;
      case "r_up":
        this.frank.newDir = 'up';
        pressed = new Arrow.RupPressedArrow();
        break;
      case "r_right":
        this.frank.newDir = 'right';
        pressed = new Arrow.RrightPressedArrow();
        break;
    }
    this.stage.addChild(pressed);
    this.stage.update();
    setTimeout( () => this.stage.removeChild(pressed), 100);

    if (arrows[0] && arrows[0].y < 40 && arrows[0].y > 10) {
      if (this.life > 0) {
        this.hit("excellent");
      }
      createjs.Ticker.off("tick", arrows[0].listener);
      this.stage.removeChild(arrows[0]);
      arrows.shift();
    } else if (arrows[0] && arrows[0].y < 55 && arrows[0].y > -5) {
      if (this.life > 0) {
        this.hit("great");
      }
      createjs.Ticker.off("tick", arrows[0].listener);
      this.stage.removeChild(arrows[0]);
      arrows.shift();
    } else if (this.life > 0) {
      this.miss();
    }
  }

  hit(tier) {
    let hitMessageBorder;
    let hitMessage;
    if (tier === "excellent") {
      this.score += 100;
      this.life = Math.min(500, this.life + 2);

      hitMessageBorder = new createjs.Text("Franktastisch!", "50px Impact", "black");
      hitMessageBorder.outline = 2;
      hitMessageBorder.x = 285;
      hitMessageBorder.y = 225;
      hitMessage = hitMessageBorder.clone();
      hitMessage.outline = 0;
      hitMessage.color = "#ffff80";
    } else if (tier === "great") {
      this.score += 50;
      this.life = Math.min(500, this.life + 1);

      hitMessageBorder = new createjs.Text("Schatzi!", "40px Impact", "black");
      hitMessageBorder.outline = 2;
      hitMessageBorder.x = 310;
      hitMessageBorder.y = 225;
      hitMessage = hitMessageBorder.clone();
      hitMessage.outline = 0;
      hitMessage.color = "#80ff80";
    }

    this.stage.addChild(hitMessage, hitMessageBorder);
    this.stage.update();
    setTimeout( () => {
      this.stage.removeChild(hitMessage, hitMessageBorder);
    }, 300);

    this.updateScore();
  }

  miss() {
    // this.life = Math.max(0, this.life - 5);

    let missMessageBorder = new createjs.Text("HE!", "40px Impact", "black");
    missMessageBorder.outline = 2;
    missMessageBorder.x = 300;
    missMessageBorder.y = 275;
    let missMessage = missMessageBorder.clone();
    missMessage.outline = 0;
    missMessage.color = "red";
    this.stage.addChild(missMessage, missMessageBorder);
    this.stage.update();

    setTimeout( () => {
      this.stage.removeChild(missMessage, missMessageBorder);
    }, 200);
    if (this.life === 0) {
      this.gameOver();
      this.stage.removeChild(missMessage, missMessageBorder);
    }
  }

  gameOver() {
    let gameOverBorder = new createjs.Text("Game over!", "60px Impact", "black");
    gameOverBorder.outline = 2;
    gameOverBorder.x = 225;
    gameOverBorder.y = 275;
    let gameOver = gameOverBorder.clone();
    gameOver.outline = 0;
    gameOver.color = "red";
    this.stage.addChild(gameOver, gameOverBorder);
    this.stage.update();
    setTimeout(() => {
      this.stage.removeChild(gameOver, gameOverBorder);
    }, 5000);
    this.clearArrows();
    this.music.pause();
    clearInterval(this.myInt);
  }

  updateScore() {
    let score = document.getElementById("score");
    score.innerHTML = this.score;
  }

  updateLife() {
    /*
    let life = document.getElementById("life");
    life.innerHTML = this.life;

    if (this.life > 50) {
      life.style.background = "green";
    } else {
      life.style.background = "red";
    }
     */
  }
}

export default Game;
